'use strict'

const counter = {
	el: {
		counterContainer: document.querySelector('.js-counter')
	},

	vars: {
		animHasStarted: false
	},

	initCounter() {
		const minDigits = this.el.counterContainer.dataset.minDig || 2
		const digitOpacity = this.el.counterContainer.dataset.opacity || 0.3

		const dpCounter = (container, options) => {
			const defaults = {
				countto: 0,
				startat: 0,
				mindig: 2,
				opacity: 0.3,
				delay: 50,
				currency: ''
			}
			const settings = { ...defaults, ...options }
			const counterObj = container
			const countTo = parseInt(counterObj.dataset.target) || parseInt(settings.countto)
			const delay = settings.delay
			const opacity = settings.opacity
			const minDig = settings.mindig
			const currency = settings.currency

			let count = countTo
			let cycles = 1
			let splitNumber = 0

			counterObj.innerHTML = ''

			const createDigitSpan = (digit) => {
				return `
					<div class="n0 dp-ct-nmb">
						<div class="dp-nmb-wp">
							${[...Array(10).keys()].map(i => `<span>${i}</span>`).join('')}
							<span>-</span><span>.</span>
						</div>
						<div class="dp-nmb-lg"></div>
					</div>`
			}

			while (count > 0) {
				counterObj.insertAdjacentHTML('afterbegin', createDigitSpan(count % 10))
				count = Math.floor(count / 10)
				cycles++
				splitNumber++
			}

			while (cycles <= minDig) {
				counterObj.insertAdjacentHTML('afterbegin', createDigitSpan(0))
				cycles++
				splitNumber++
			}

			if (currency) {
				counterObj.insertAdjacentHTML('afterbegin', `
					<div class="n0 dp-ct-nmb">
						<div class="dp-nmb-wp">
							<span>${currency}</span>
						</div>
						<div class="dp-nmb-lg"></div>
					</div>`)
			}

			const elements = Array.from(counterObj.querySelectorAll('div.dp-ct-nmb'))
			let n = 0
			count = countTo

			const doNumber = () => {
				const spanclass = `n${count % 10}`
				count = Math.floor(count / 10)
				const lastElement = elements[elements.length - 1 - n]
				lastElement.classList.add(spanclass)
				lastElement.classList.remove('n0')
				if (lastElement.classList.contains('fade')) {
					lastElement.style.opacity = opacity
					lastElement.classList.remove('fade')
				}
			}

			const transition = () => {
				if (n < elements.length) {
					doNumber()
					n++
					setTimeout(transition, delay)
				}
			}

			setTimeout(transition, delay)
		}

		dpCounter(this.el.counterContainer, { mindig: minDigits, opacity: digitOpacity })
		this.vars.animHasStarted = true
	},

	fxStartCounter (element) {
		const triggerCounterIntersection = window.pageYOffset + element.offsetHeight

		if (triggerCounterIntersection > element.offsetHeight && this.vars.animHasStarted === false)
			this.initCounter()
	},

	init() {
		if (!this.el.counterContainer) return
	}
}

counter.init()